import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { selectListItems } from "../../../../../../../../redux/library/selector";

const DBNBizBrandMappingListComponent = ({ orgRegistry }: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const libraryData = useSelector(selectListItems);

    const [rowData, setRowData] = useState<any[]>([]);

    useEffect(() => {
        if (orgRegistry?.AccountInfo?.BrandMappings) {
            setRowData(orgRegistry?.AccountInfo?.BrandMappings);
        }
    }, [orgRegistry]);

    const handleAdd = () => {
        navigate(`/management/dbn-cloud/biznet/dbnbizs/${orgRegistry?.OrgRegistryId}/map-brand/0`);
    };

    const handleEdit = (data: any) => {
        navigate(`/management/dbn-cloud/biznet/dbnbizs/${orgRegistry?.OrgRegistryId}/map-brand/${data?.Id}`);
    };

    return (
        <div className="p-4">
            <h2 className="text-lg font-medium mb-6 text-start">DBNBiz Brand Mapping</h2>

            {rowData?.length === 0 ? (
                <div className="text-center text-gray-600 py-6">
                    <p className="mb-2">No Brand Mapped for this DBNBiz.</p>
                    <button
                        onClick={handleAdd}
                        className="text-blue-600 hover:underline font-medium"
                    >
                        Click here to map a Brand
                    </button>
                </div>
            ) : (
                <div className="space-y-4">
                    {rowData?.map((item) => (
                        <div
                            key={item.Id}
                            onClick={() => handleEdit(item)}
                            className="flex items-center border rounded-lg shadow hover:shadow-md transition cursor-pointer p-4 bg-white"
                        >
                            {/* Image Section */}
                            <div className="w-24 h-24 flex items-center justify-center border rounded-md overflow-hidden bg-gray-50 mr-4">
                                {item?.Configurations?.Logos?.[0]?.Url ? (
                                    <img
                                        src={item.Configurations.Logos[0].Url}
                                        alt={item?.Name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                ) : (
                                    <span className="text-xs text-gray-400">No Image</span>
                                )}
                            </div>

                            {/* Text Content Section */}
                            <div className="flex-1">
                                <div className="flex flex-col gap-y-2">
                                    <div className="flex">
                                        <span className="w-32 text-sm text-gray-500 font-medium">Brand Name:</span>
                                        <span className="text-base font-semibold text-gray-900">{item?.Name || "N/A"}</span>
                                    </div>
                                    {item?.Description && (
                                        <div className="flex">
                                            <span className="w-32 text-sm text-gray-500 font-medium">Description:</span>
                                            <span className="text-sm text-gray-700">{item.Description}</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default DBNBizBrandMappingListComponent;
